import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { map, Observable } from 'rxjs';

import { RoleService } from '../_services/role.service';

export const AuthGuardGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  return checkUserLogin(router, state.url);
};

function checkUserLogin(route: Router, attemptedUrl: string): boolean {
  const auth = JSON.parse(localStorage.getItem('partner_user') || '{}');
  if (!auth) {
    route.navigate(['/login'], { queryParams: { returnUrl: attemptedUrl } });
    return false;
  }

  if (!auth.token) {
    route.navigate(['/login'], { queryParams: { returnUrl: attemptedUrl } });
    return false;
  }
  if (auth.userType != 'PARTNER' && auth.userType != 'AGENT') {
    route.navigate(['/login'], { queryParams: { returnUrl: attemptedUrl } });
    return false;
  }
  return true;
}
export const isUseActiveGuard = () => {
  const router = inject(Router);
  const toasterService = inject(ToastrService);
  return isUserActive(router, toasterService);
};

function isUserActive(route: Router, toasterService: ToastrService) {
  const auth = JSON.parse(localStorage.getItem('partner_user') || '{}');
  if (auth.partnerState == 'ACTIVE' && auth.userType === 'PARTNER') {
    toasterService.error(
      $localize`Ton compte est en attente d'approbation`,
      ''
    );
    route.navigate(['/dashboard']);
    return false;
  }
  return true;
}
export const checkUseRoleGuard = (ActivatedRouteSnapshot: any) => {
  const router = inject(Router);
  const roleService = inject(RoleService);
  const toasterService = inject(ToastrService);
  return checkUseRole(
    router,
    ActivatedRouteSnapshot,
    toasterService,
    roleService
  );
};
function checkUseRole(
  router: Router,
  activatedRouteSnapshot: ActivatedRouteSnapshot,
  toasterService: ToastrService,
  roleService: RoleService
): Observable<boolean> | boolean {
  const auth = JSON.parse(localStorage.getItem('partner_user') ?? '{}');
  if (auth.userType === 'USER' || auth.userType === 'PARTNER') {
    return true;
  }
  const obj = {
    userId: auth.partnerId,
  };
  return roleService._getUserRoleByUserId(obj).pipe(
    map((data: any) => {
      const userRole: any = data.data.useCasesList;
      const checkRole = userRole.find(
        (element: any) =>
          element.useCaseId == activatedRouteSnapshot.data['useCaseId']
      );
      let msg = '';
      if (checkRole) {
        const checkPerMissions = checkRole.permissionIds.find(
          (element: any) => element == activatedRouteSnapshot.data['pid']
        );
        if (activatedRouteSnapshot.data['pid'] == 1) {
          msg = $localize`Vous n'avez pas l'accès en lecture à cette ressource`;
        }
        if (activatedRouteSnapshot.data['pid'] == 2) {
          msg = $localize`Vous n'avez pas l'accès en écriture à cette ressource`;
        }
        if (activatedRouteSnapshot.data['pid'] == 3) {
          msg = $localize`Vous n'avez pas le droit de supprimer cette ressource`;
        }
        if (!checkPerMissions) {
          toasterService.error(msg, '');
          router.navigate(['/dashboard']);
          return false;
        }
        return true;
      }
      router.navigate(['/dashboard']);
      return false;
    })
  );
}
